import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=06c620e3&scoped=true&"
import script from "./contact-us.vue?vue&type=script&lang=js&"
export * from "./contact-us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c620e3",
  null
  
)

export default component.exports